import { render, staticRenderFns } from "./category-tiles-table.vue?vue&type=template&id=3e3890e0&scoped=true"
import script from "./category-tiles-table.vue?vue&type=script&lang=js"
export * from "./category-tiles-table.vue?vue&type=script&lang=js"
import style0 from "./category-tiles-table.vue?vue&type=style&index=0&id=3e3890e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3890e0",
  null
  
)

export default component.exports